import React from "react";
import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../store/configureStore";
import { useState } from "react";
import { CharacterActions } from "../../../store/stores/collection/characters/CharacterStore.Actions";
import { BreakdownWindow } from "../../theming/breakdown-window";
import { Loader } from "../../theming/loader/Loader";
import { ThemedButton } from "../../inputs/buttons/ThemedButton";

export const CharacterCreator = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { characters, creating } = useAppSelector(app => app.character);
    const currentCharacterNames = characters.map(c => c.name);

    const [name, setName] = useState("");

    const nameInvalid = currentCharacterNames.any(characterName => characterName == name);

    const postCreateCallback = (id: string) => navigate(`/Characters/${id}/Sheet`);

    const create = () => {
        if (nameInvalid) {
            return;
        }
        dispatch(CharacterActions.createNewCharacter({name}, postCreateCallback));
    }
    return (
        <BreakdownWindow close={() => navigate("/Characters")} heading={<h1>Create Character</h1>}>
            <div className="form-field">
                <label>Name:</label>
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            {creating && <Loader>Creating Character</Loader>}
            <ThemedButton disabled={nameInvalid} onClick={create}>Create</ThemedButton>
        </BreakdownWindow>
    )
}